import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "User Dashboards", desc: "Operational interfaces for teams, customers, and admins with the right information at the right depth." },
  { title: "Authentication & Roles", desc: "Secure account flows, permissions, and access models shaped to real user responsibilities." },
  { title: "Business Workflows", desc: "Forms, states, approvals, notifications, and process logic built around your operating model." },
  { title: "Billing & Admin Tools", desc: "Subscription flows, invoicing support, and internal control surfaces where needed." },
  { title: "Analytics Layers", desc: "Usage visibility and operational reporting built into the product rather than added as an afterthought." },
  { title: "Deployment Readiness", desc: "Production architecture, QA, and release workflows that support a proper launch." },
];

const WebApps = () => (
  <StitchFeaturePage
    label="WEB APPLICATION DEVELOPMENT"
    title="Web apps for"
    titleAccent="real operations."
    subtitle="From internal systems to customer-facing platforms, we build web applications that solve actual business workflows."
    features={features}
    ctaLabel="START A WEB APP BUILD"
  />
);

export default WebApps;
